// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".spinner-container[data-v-0b71e095]{bottom:0;left:0;opacity:0;position:absolute;right:0;top:0;transition:opacity .5s ease-in-out;z-index:-1000}.spinner-container.on[data-v-0b71e095]{opacity:1;position:fixed;z-index:1000}.spinner-bg[data-v-0b71e095]{align-items:center;background-color:hsla(0,0%,100%,.8);display:flex;height:100%;justify-content:center;margin:auto;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
